module.exports = __webpack_public_path__ + "01_long_brown.773b2d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_long_brown.png
// module id = nsOB
// module chunks = 0